





















import { computed, defineComponent, PropType, ref, watch } from '@vue/composition-api';
import { CompanyStatus } from '@/graphql';
import CompanyStatusChip from '@/components/Chips/CompanyStatusChip.vue';
import { companyStatus } from '@/constants';

export default defineComponent({
  components: { CompanyStatusChip },
  props: {
    value: {
      type: String as PropType<CompanyStatus | null>,
      required: false,
      default: null,
    },
    loading: {
      type: Boolean,
      required: false,
      default: false,
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
    label: {
      type: String as PropType<string | null>,
      required: false,
      default: null,
    },
    hasCompanyDebitAgreement: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  setup(props, { emit }) {
    const model = ref<CompanyStatus | null>(props.value);

    watch(
      () => props.value,
      (value) => {
        model.value = value;
      },
    );

    return {
      model,
      items: computed<CompanyStatus[]>(() => {
        const list: CompanyStatus[] = Object.keys(companyStatus) as CompanyStatus[];

        // @TODO: specify requirements for status availability

        // if (!props.hasCompanyDebitAgreement) {
        //   list.splice(list.indexOf(CompanyStatus.Unoccupied));
        // }

        // add selected item to list if not included (anymore)
        if (model.value && !list.includes(model.value)) {
          list.push(model.value);
        }

        return list;
      }),
      input: (companyStatus: CompanyStatus) => {
        emit('input', companyStatus);
      },
    };
  },
});
